import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-meter-consumption-dropdown-filter',
  templateUrl: './meter-consumption-dropdown-filter.component.html',
  styleUrls: ['./meter-consumption-dropdown-filter.component.scss'],
})
export class MeterConsumptionDropdownFilterComponent {
  @Input() filterOptions: any;
  @Input() upperFilterOptions: any;
  @Input() lowerFilterOptions: any;

  @Input() value: any;
  @Output() optionSelect = new EventEmitter();

  public select = (item: any): void => {
    const index = this.filterOptions.findIndex((e: any) => e.label === item.label);
    this.optionSelect.emit(index);
  };
}
